<script setup lang="ts">
import { useMapStore } from '@apps/main/new-desktop/core/stores';

import { TransportType } from '@libs/trip-planner-interfaces';

import type { ItineraryUpsellNoTransportSegment } from '../../models';
import { useTripOverviewPageStore } from '../../stores';

import TransportBanner from './upsell/TransportBanner.vue';

interface ItineraryUpsellNoTransportSegmentProps {
  segment: ItineraryUpsellNoTransportSegment;
}

const props = defineProps<ItineraryUpsellNoTransportSegmentProps>();

const tripOverviewPageStore = useTripOverviewPageStore();
const mapStore = useMapStore();
function selectTransport(transport: TransportType): void {
  tripOverviewPageStore.selectTransport(props.segment, transport);
}
</script>

<template>
  <TransportBanner
    :routes="tripOverviewPageStore.getAddFlightsModalRoutes()"
    :start-positon="mapStore.startingLocation"
    :end-position="mapStore.endLocation"
    :country="segment.destination"
    @add-flight="selectTransport(TransportType.Flight)"
    @add-ferry="selectTransport(TransportType.Ferry)"
    @select-transport="selectTransport($event)"
    @add-optimized-flights="
      tripOverviewPageStore.confirmAddFlightsModal($event)
    "
  />
</template>

<style scoped lang="scss">
.exp-transport-banner {
  margin: 0 var(--spacing-24) var(--spacing-24) var(--spacing-24);

  @include for-less-or-equal-than-599-px {
    margin: 0 var(--spacing-12) var(--spacing-24) var(--spacing-12);
  }

  ::after {
    content: '';
    height: 25px;
    width: 0px;
    border-right: 1px dashed var(--color-neutral-70);
    position: absolute;
    bottom: -25px;
    left: 24px;
  }
}
</style>
